export default "/ccbaa8b9a44abf09c1efe95cd866733b.jpg";